import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDeniedView = ({ isDark, accessDenied }) => {
    const navigate = useNavigate();
    
    return (
        <div className={`min-h-screen flex items-center justify-center transition-colors duration-200 ${
            isDark ? 'bg-[#000000]' : 'bg-[#f5f5f5]'
        }`}>
            <div className="flex flex-col justify-center items-center gap-[16px] w-[305px]">
                {/* Icon and Title */}
                <div className="flex flex-col justify-center items-center gap-[6px] w-full">
                    {/* Warning Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
                        <path d="M31.2213 26.3847C32.2541 24.6021 32.2607 22.4774 31.2345 20.7013L20.9332 2.86147C19.9136 1.06565 18.0717 0 16.0062 0C13.9407 0 12.0988 1.07223 11.0792 2.85489L0.764735 20.7144C-0.261448 22.5102 -0.25487 24.6481 0.784469 26.4308C1.81065 28.1937 3.64594 29.2528 5.69831 29.2528H26.2746C28.3335 29.2528 30.182 28.1806 31.2213 26.3847ZM28.9848 25.0954C28.4125 26.0821 27.3994 26.6676 26.268 26.6676H5.69173C4.57345 26.6676 3.567 26.0953 3.00787 25.1283C2.44215 24.1482 2.43557 22.9773 3.00129 21.9906L13.3157 4.13762C13.8749 3.15749 14.8747 2.57861 16.0062 2.57861C17.131 2.57861 18.1375 3.16406 18.6966 4.1442L29.0045 21.9972C29.5571 22.9576 29.5505 24.1153 28.9848 25.0954Z" fill={isDark ? '#EF4444' : '#B42318'}/>
                        <path d="M16 10C15.4477 10 15 10.4477 15 11V17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17V11C17 10.4477 16.5523 10 16 10Z" fill={isDark ? '#EF4444' : '#B42318'}/>
                        <path d="M16 20C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20Z" fill={isDark ? '#EF4444' : '#B42318'}/>
                    </svg>
                    {/* Title */}
                    <div className={`w-full font-semibold text-[16px] leading-[21px] text-center ${
                        isDark ? 'text-[#EF4444]' : 'text-[#B91C1C]'
                    }`}>
                        Submission Unavailable
                    </div>
                </div>
                {/* Message */}
                <div className={`font-normal text-[16px] leading-[21px] text-center ${
                    isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                }`}>
                    {accessDenied}
                </div>
                {/* Button */}
                <button
                    onClick={() => navigate('/submission')}
                    className={`flex justify-center items-center px-[16px] py-[8px] rounded-[8px] transition-colors border-0 outline-none ${
                        isDark
                            ? 'bg-[#cd6d2c] hover:bg-white'
                            : 'bg-[#072837] hover:bg-[#0a3a4d]'
                    }`}
                    style={{ filter: 'drop-shadow(0px 0px 56px rgba(0, 0, 0, 0.04))' }}
                >
                    <span className={`font-semibold text-[16px] leading-[21px] ${
                        isDark ? 'text-[#000000]' : 'text-white'
                    }`}>
                        Go Back
                    </span>
                </button>
            </div>
        </div>
    );
};

export default AccessDeniedView;
